module.exports = __webpack_public_path__ + "static/media/logo_gastrob.207b3edd.png";